<div *ngIf="!isHidden">
    <aggregate-card [aggregate]="aggregate" [aggregateCriteria]="aggregateCriteria">
    </aggregate-card>
</div>